import logo from "../../assets/logo_top.png";

const header = () => (
  <div className="bg-black h-[120px] flex items-center px-[30px] lg:h-[90px]">
    <img src={logo} alt="logo" />
  </div>
);

export default header;
